<template>
  <ValidationObserver ref="scopeForm" tag="fieldset" v-slot="{ invalid, pristine }" >
    <b-form @submit.prevent>
    <b-row>
      <b-col>
        <distribution-form-group
          :label="$t('type') | capitalize"
          label-cols="2"
          id="college"
          vid="college"
          ref="college"
          rules="required"
          v-slot="{ state }"
          :hide-feedback="payoutMode === payoutModes.VIEW"
          >
          <b-col v-if="payoutMode === payoutModes.VIEW" class="view-values" cols="10"> {{ collegeText(payoutData.scope.college) }} </b-col>
          <b-form-select v-else required v-model="payoutData.scope.college" :options="collegeOptions" :state="state">
          </b-form-select>
          <fa-icon v-if="payoutMode === payoutModes.EDIT" :icon="['fa', 'pen']" class="ml-1 edit-svg"/>
        </distribution-form-group>
      </b-col>
    </b-row>
    <!-- Collective/society -->
    <b-row class="mt-2">
      <b-col>
        <distribution-form-group
          :label="$t('collective_society')"
          label-cols="2"
          id="collectiveSociety"
          vid="collectiveSociety"
          ref="collectiveSociety"
          :rules="selectedSociety.except !=='all'? 'required' : ''"
          v-slot="{ state }"
          :hide-feedback="payoutMode === payoutModes.VIEW"
        >
        <b-col v-if="payoutMode === payoutModes.VIEW" class="view-values d-flex" cols="10">
          <div class="select">
            <span>{{ payoutData.scope.societies.select | capitalize }}</span>
          </div>
          <div class="values">
            <span>{{ societyText(payoutData.scope.societies.ids) }}</span>
          </div>
        </b-col>
        <b-input-group v-else class="include-exclude-append">
          <template v-slot:append>
            <include-exclude-selector
              :options="memberCollectiveOptions"
              :except-string="$t('all_except') | capitalize"
              :include-string="$t('include_specific') | capitalize"
              :placeholder="getPlaceholder('selectedSociety')"
              label=""
              label-cols="0"
              v-model="selectedSociety"
              :enable-all="true"
              selectorCols="col-3 pr-0"
            />
          </template>
          <b-form-select required v-model="selectedSociety.values" :options="[]" :state="state" :disabled="true" :hidden="true"/>
        </b-input-group>
        <fa-icon v-if="payoutMode === payoutModes.EDIT" :icon="['fa', 'pen']" class="ml-1 edit-svg"/>
        </distribution-form-group>
      </b-col>
    </b-row>
    <!-- Copyrights -->
    <b-row class="mt-2">
      <b-col>
        <distribution-form-group
          :label="$t('copyrights') | capitalize"
          label-cols="2"
          id="copyrights"
          vid="copyrights"
          ref="copyrights"
          :rules="copyrightsRule"
          v-slot="{ state }"
          :disabled="selectedSociety.except === 'all'"
          :hide-feedback="payoutMode === payoutModes.VIEW"
        >
        <b-col v-if="payoutMode === payoutModes.VIEW" class="view-values d-flex" cols="10">
          <div class="select">
            <span>{{ payoutData.scope.copyrights.select | capitalize }}</span>
          </div>
          <div class="values">
            <span>{{ copyrightsText(payoutData.scope.copyrights.codes) }}</span>
          </div>
        </b-col>
        <b-input-group v-else class="include-exclude-append">
          <template v-slot:append>
            <include-exclude-selector
              :options="copyrightsOptions"
              :except-string="$t('all_except') | capitalize"
              :include-string="$t('include_specific') | capitalize"
              :placeholder="getPlaceholder('selectedCopyrights')"
              label=""
              label-cols="0"
              v-model="selectedCopyrights"
              :enable-all="true"
              selectorCols="col-3 pr-0"
            />
          </template>
          <b-form-select required v-model="selectedCopyrights.values" :options="[]" :state="state" :disabled="true" :hidden="true" />
        </b-input-group>
        <fa-icon v-if="payoutMode === payoutModes.EDIT" :icon="['fa', 'pen']" class="ml-1 edit-svg"/>
        </distribution-form-group>
      </b-col>
    </b-row>
    <!-- tariff periods -->
    <b-row class="mt-2"> 
      <b-col>
        <distribution-form-group
          :label="$t('tariff_periods') | capitalize"
          label-cols="2"
          id="tariffPeriods"
          vid="tariffPeriods"
          ref="tariffPeriods"
          :rules="selectedDistribution.except !=='all'? 'required' : ''"
          :hide-feedback="payoutMode === payoutModes.VIEW"
          >
          <b-col v-if="payoutMode === payoutModes.VIEW" class="view-values d-flex" cols="10">
            <PaginatedDistributionsModal
              v-if="payoutData.distributionsCount && payoutData.distributionsCount !== 0"
              :id="payoutData.id"
              :distributions="payoutData.scope?.distributions?.ids || []"
            />
          </b-col>
          <b-input-group v-else class="custom-select-search">
            <template v-slot:append>
              <b-form-select class="col-3" v-model="selectedDistribution.except">
                <b-form-select-option value="all">{{ $t("all") | capitalize }}</b-form-select-option>
                <b-form-select-option :value="false">{{ $t('include_specific') | capitalize }}</b-form-select-option>
                <b-form-select-option :value="true">{{ $t('all_except') | capitalize }}</b-form-select-option>
              </b-form-select>
              <PaginatedDistributionsModal
                @updatedistributions="updateSelectedDistributions"
                @haschanged="manualDirty = true"
                edit-mode
                :id="payoutData.id"
                :distributions="payoutData.scope?.distributions?.ids || []"
                :payout-data="payoutData"
                :selected-copyrights="selectedCopyrights"
                :all-tariffs="selectedDistribution.except === 'all'"
                :copyrights-options="copyrightsOptions"
                />
            </template>
          </b-input-group>
        </distribution-form-group>
      </b-col>
    </b-row>
    <!-- closeout -->
    <b-row class="mt-2">
      <b-col>
        <distribution-form-group
          :label="$t('include_closeouts') | capitalize"
          label-cols="2"
          id="closeouts"
          vid="closeouts"
          ref="closeouts"
          rules="required"
          v-slot="{ state }"
          :hide-feedback="payoutMode === payoutModes.VIEW"
        >
          <b-col v-if="payoutMode === payoutModes.VIEW" class="view-values" cols="10"> {{ payoutData.scope.includeCloseoutTransactions ? "Yes" : "No" }} </b-col>
          <b-form-select v-else required v-model="payoutData.scope.includeCloseoutTransactions" :options="closeoutsOptions" :state="state" />
          <fa-icon v-if="payoutMode === payoutModes.EDIT" :icon="['fa', 'pen']" class="ml-1 edit-svg"/>
        </distribution-form-group>
      </b-col>
    </b-row>
    <!-- threshold -->
    <b-row class="mt-2">
      <b-col>
        <distribution-form-group
          :label="$t('min_threshold') | capitalize"
          label-cols="2"
          id="threshold"
          vid="threshold"
          ref="threshold"
          v-slot="{ state }"
          :hide-feedback="payoutMode === payoutModes.VIEW"
        >
          <b-col v-if="payoutMode === payoutModes.VIEW" class="view-values" cols="10">${{ parseInt(payoutData.scope.minThreshold) | formatNumber(0, 0) }}</b-col>
          <b-form-input v-else v-model="payoutData.scope.minThreshold" :state="state"/>
          <fa-icon v-if="payoutMode === payoutModes.EDIT" :icon="['fa', 'pen']" class="ml-1 edit-svg"/>
        </distribution-form-group>
      </b-col>
    </b-row>
    <div class="fixed-footer">
      <div class="d-flex justify-content-end">
        <b-button
          class="ml-3 mr-3 btn-outline-red"
          type="submit"
          :disabled="invalid"
          v-if="payoutMode === payoutModes.CREATE"
          @click="onSubmit"
        >
          {{ $t("set_scope") | capitalize }}
        </b-button>
        <b-button v-if="payoutMode === payoutModes.VIEW && canEdit" class="btn-outline-red" @click="editForm">{{ $t("modify_scope") | capitalize }}</b-button>
        <b-button v-if="payoutMode === payoutModes.EDIT && !isSaving" class="btn-outline-dark mr-3" @click="cancel">{{ $t("cancel") | capitalize }}</b-button>
        <b-button v-if="payoutMode === payoutModes.EDIT" class="btn-outline-red" :disabled="isSaving || invalid || (pristine && !manualDirty)" @click="onSubmit">
          {{ $t("save_changes") | capitalize }}
          <b-spinner v-if="isSaving" variant="light" class="spinner" small/>
        </b-button>
        <b-button
        class="btn-outline-red ml-3 mr-3"
        :disabled="isLoadTransactionsDisabled"
        v-if="payoutMode !== payoutModes.CREATE"
        @click="handleLoadTransactions"
        >
          {{ $t("load_transactions") | startcase }}
        </b-button>
      </div>
    </div>
    </b-form>
    <modal
      id="confirmation-modal"
      :customTitle="$t('modify_scope') | capitalize"
      modal-class="custom-modal info"
      modalType="edit"
      size="lg"
      @ok="onSubmit(false)"
      centered
      :okTitle="$t('confirm') | capitalize"
    >
      <template v-if="scopeMessage && scopeMessage.belowMoratoriumDistributions.length">
        <p>Following distributions with amount balance below moratorium minimum will be added to the Payout:</p>
        <ul>
          <li v-for="distribution in scopeMessage.belowMoratoriumDistributions" :key="distribution">{{ distribution }}</li>
        </ul>
      </template>

      <template v-if="scopeMessage &&scopeMessage.lowBalanceDistributions.length">
        <p>Following distributions with amount balance below payable amount will be excluded from the Payout:</p>
        <ul>
          <li v-for="distribution in scopeMessage.lowBalanceDistributions" :key="distribution">{{ distribution }}</li>
        </ul>
      </template>

      <template v-if="scopeMessage &&scopeMessage.moratoriumDistributions.length">
        <p>Following distributions with active moratorium flag will be excluded from the Payout:</p>
        <ul>
          <li v-for="distribution in scopeMessage.moratoriumDistributions" :key="distribution">{{ distribution }}</li>
        </ul>
      </template>
    </modal>
  </ValidationObserver>
</template>
<script>

import { mapActions, mapState } from "vuex"
import { payoutModes, payoutStatuses } from "@/constants"
import DistributionFormGroup from "@/components/DistributionFormGroup"
import PaginatedDistributionsModal from "../PaginatedDistributionsModal"
import { ValidationObserver } from "vee-validate"
import { capitalize } from "lodash"

export default {
  name: "ScopeSection",
  components: { DistributionFormGroup, ValidationObserver, PaginatedDistributionsModal },
  props: {
    payoutData: {
      type: Object,
    },
    payoutMode: String,
    canEdit: Boolean,
    selectedSociety: Object,
    selectedDistribution: Object,
    selectedCopyrights: Object,
  },
  computed: {
    ...mapState("consts", ["copyrights","memberCollectives","tariffs"]),
    memberCollectiveOptions () {
      return this.memberCollectives.map(x => ({ name: x.name, value: x.name }))
    },
    copyrightsOptions () {
      return this.copyrights.map(c => ({ name: c.text, value: c.code }))
    },
    isLoadTransactionsDisabled () {
      const { status } = this.payoutData
      return (
        this.payoutMode === payoutModes.EDIT || 
        [
          payoutStatuses.IN_REVIEW,
          payoutStatuses.COMPLETED,
          payoutStatuses.CANCELLED,
          payoutStatuses.LOADING_TRANSACTIONS
        ].includes(status)
      )
    },
    copyrightsRule () {
      if (this.selectedSociety.except === "all")
        return ""
      else if (this.selectedCopyrights.except !== "all")
        return "required"
      else
        return ""
    },
  },
  data () {
    return {
      scopeMessage: null,
      manualDirty: false,
      collegeOptions: [
        { value: "maker", text: capitalize(this.$t("maker")) },
        { value: "performer", text: capitalize(this.$t("performer")) },
        { value: "maker_and_performer", text: capitalize(this.$t("maker_and_performer")) }
      ],
      closeoutsOptions: [
        { value: "true", text: capitalize("yes") },
        { value: "false", text: capitalize("no") }
      ],
      isLoading: false,
      payoutModes,
      payoutStatuses,
      tariffPeriodOptions: [],
      isSaving: false,
    }
  },

  methods: {
    ...mapActions("consts", ["getCopyrights", "getTariffs"]),
    ...mapActions("alert", ["success", "error", "warning"]),

    editForm () {
      this.$emit("change-payout-mode", payoutModes.EDIT)
      this.selectedSociety.except = this.getSelectValue(this.payoutData.scope.societies.select)
      this.selectedSociety.values = this.generateSocietyOptions()
      this.selectedCopyrights.except = this.getSelectValue(this.payoutData.scope.copyrights.select)
      this.selectedCopyrights.values = this.generateCopyrightOptions()
      this.selectedDistribution.except = this.getSelectValue(this.payoutData.scope.distributions.select)
    },
    cancel () {
      this.manualDirty = false
      this.$emit("reset")
    },
    handleLoadTransactions () {
      this.$api.payouts.applyPayout(this.payoutData.id).then(() => {
        this.success("Payout transactions are being loaded. Please wait.")
        let newPayout = { ...this.payoutData, status: payoutStatuses.LOADING_TRANSACTIONS }
        this.$emit("update-payout-data", newPayout)
      }).catch(() => {
        this.error("Failed to load transactions. Please contact administrator or try again.")
      })
    },
    collegeText (value) {
      return this.collegeOptions.find(item => item.value === value)?.text || ""
    },
    societyText (values) {
      if (Array.isArray(values)) {
        return values.join(", ")
      }
      return ""
    },
    copyrightsText (values) { 
      if (Array.isArray(values)) {
        return values
          .map(value =>
            this.copyrightsOptions.find(item => item.value === value)?.name || ""
          ).join(", ")
      }
      return ""
    },
    mapTariffs (tariffObj) {
      return tariffObj ? Object.values(tariffObj).map(item => item.description) : []
    },

    generateSocietyOptions () {
      const societyIds = this.payoutData.scope.societies.ids
      return societyIds.map(id => {
        const match = this.memberCollectiveOptions.find(option => option.value === id)
        return {
          name: match.name,
          value: id,
        }
      })
    },

    generateCopyrightOptions () {
      const copyrightIds = this.payoutData.scope.copyrights.codes
      return copyrightIds.map(id => {
        const match = this.copyrightsOptions.find(option => option.value === id)
        return {
          name: match.name,
          value: id,
        }
      })
    },
    getPlaceholder (key) {
      if (this[key]?.except === "all")
        return ""
      return this[key]?.except ? this.$t("except_placeholder") : this.$t("include_placeholder")
    },
    handleUpdateError (response) {
      const { data, status } = response
      let message = ""
      if (status === 400) {
        this.error(capitalize(this.$t("form_contains_errors")))
        this.$refs.scopeForm.setErrors(data)
      } else if (status === 422) {
        message = "Failed to update payout. Please correct the data and try again."
        if (data.nonFieldErrors) {
          message = message + "\n" + data.nonFieldErrors.map(e => e.message).join("\n")
        }
      } else {
        message = "Failed to update payout. Please contact administrator or try again."
      }
      this.error(message)
    },
    handleUpdateSuccess (response) {
      this.$emit("update-payout-data", response.data.results)
      this.$emit("change-payout-mode", payoutModes.VIEW)
      this.success(capitalize(this.$t("saved_changes")))
      this.manualDirty = false
      this.$nextTick(() => {
        this.$refs.scopeForm.reset()
      })
    },
    updateSelectedDistributions (newDistributions) {
      this.selectedDistribution.values = newDistributions
    },
    async updateScope (preview) {
      const getSelectType = (exceptValue) => {
        if (exceptValue === true) return "exclude"
        if (exceptValue === false) return "include"
        return "all"
      }

      const data = {
        scope: {
          college: this.payoutData.scope.college,
          minThreshold: Number(this.payoutData.scope.minThreshold),
          distributions: {
            ids: this.selectedDistribution.values,
            select: getSelectType(this.selectedDistribution.except),
          },
          societies: {
            ids: this.selectedSociety.values.map(t => t.value),
            select: getSelectType(this.selectedSociety.except),
          },
          copyrights: {
            codes: this.selectedCopyrights.values.map(t => t.value),
            select: getSelectType(this.selectedCopyrights.except),
          },
          includeCloseoutTransactions: this.payoutData.scope.includeCloseoutTransactions,
        }
      }
      try {
        let resp = await this.$api.payouts.updatePayout(this.payoutData.id, data, { "preview": preview })
        return { "response": resp, "success": true }
      } catch (e) {
        return { "response": e.response, "success": false }
      }
    },
    async onSubmit (preview = true) {
      this.isSaving = true
      this.scopeMessage = null
      let { response, success } = await this.updateScope(preview)
      if (!success) {
        this.handleUpdateError(response)
        this.isSaving = false
        return
      }
      if (!preview) {
        this.handleUpdateSuccess(response)
        this.isSaving = false
        return
      }
      if (response.data.message) {
        this.scopeMessage = response.data.message
        this.$bvModal.show("confirmation-modal")
      } else {
        let { response, success } = await this.updateScope(false)
        if (success) {
          this.handleUpdateSuccess(response)
        } else {
          this.handleUpdateError(response)
        }
      }
      this.isSaving = false
    },
    getSelectValue (value) {
      const valueMap = {
        "exclude": true,
        "include": false,
        "all": "all"
      }
      return valueMap[value]
    },
  },
  watch: {
    "selectedSociety.except" (newVal) {
      if (newVal === "all") {
        this.selectedSociety.values = []
        this.selectedCopyrights = { except: "all", values: [] }
      }
    },
    "selectedDistribution.except" (newVal) {
      if (newVal === "all") {
        this.selectedDistribution.values = []
      }
    },
    "selectedCopyrights.except" (newVal) {
      if (newVal === "all") {
        this.selectedCopyrights.values = []
      }
    },
    "payoutData.scope.college" (newVal, oldVal) {
      if (!oldVal || !newVal) return

      const hasSelectedDistributions = this.selectedDistribution.values && this.selectedDistribution.values.length > 0
      
      if (hasSelectedDistributions && this.selectedDistribution.except !== "all") {
        this.warning(this.$t("changing_college_warning"))
      }
    },
  },
  mounted () {
    if (!this.copyrights.length) {
      this.getCopyrights()
    }
    if (!this.tariffs.length) {
      this.getTariffs()
    }
    if (this.payoutData.status === payoutStatuses.NOT_STARTED) {
      this.payoutMode = payoutModes.CREATE
    }
  },
}
</script>

<style lang="css" scoped>

.custom-select-search {
  .input-group-append {
    width: stretch;
    column-gap: 20px;
    .custom-select {
      border-radius: 0.25rem;
      background-color: white;
    }
    .select-search-input {
      padding: 0;
    }
    ::v-deep .input-group {
      padding-right: 20px;
    }
    ::v-deep .form-control[readonly] {
      background-color: transparent;
    }
    ::v-deep .form-control[disabled] {
      background-color: transparent;
      opacity: 0.6;
      cursor: not-allowed;
      pointer-events: all;
    }
  }
}

.include-exclude-append {
  width: stretch;
  .input-group-append {
    width: stretch;
    .includeExcludeSelector {
      width: stretch;
      column-gap: 20px;
    }
    ::v-deep .custom-select {
      border-radius: 0.25rem;
      background-color: white;
    }
  }
}

::v-deep .multiselect--disabled {
  cursor: not-allowed;
  pointer-events: all;
}

::v-deep .multiselect--disabled .multiselect__select {
    background-color: white !important;
    cursor: not-allowed;
  }

.view-values {
  .select {
    width: 10%;
  }
  .values {
    width: 90%;
  }
}
.edit-svg {
  height: 32px;
}
</style>